<template>
  <div class="the-box">
    <div v-show="step==='input'">
      <h4 style="margin-bottom: 16px">Complete the form below and one of our digital experts will reach out to you.</h4>
    <b-form-group label="What are you trying to accomplish? (Campaign goals/objectives)"
                  :invalid-feedback="textValid.text" :state="textValid.state">
      <b-form-textarea v-model="order.text" placeholder=""  :rows="3" @input="textChange()" :state="textValid.state"/>
    </b-form-group>


    <b-form-group label="How do you wish to reach new prospects? Check all that apply.">
      <b-form-checkbox-group v-model="order.prospectsType" stacked>
        <b-form-checkbox value="Email">Email</b-form-checkbox>
        <b-form-checkbox value="Mobile & Desktop Display banners">Mobile & Desktop Display banners</b-form-checkbox>
        <b-form-checkbox value="Social Media Ads">Social Media Ads</b-form-checkbox>
        <b-form-checkbox value="Other" v-model="other" style="display: inherit">
          Other<b-form-input type="text" v-model="prospectsTypeOther" size = "sm" style="margin-left: 16px"/>
        </b-form-checkbox>
      </b-form-checkbox-group>
    </b-form-group>

    <b-form-group label="Campaign Budget: (dropdown with these options)">
      <b-form-select v-model="order.budget" :options="budgetOptions" />
    </b-form-group>

    <b-form-group label="Desired Start Date: (dropdown with these options)">
      <b-form-select v-model="order.startDate" :options="startDateOptions" />
    </b-form-group>
      <b-form-group label="Name" :invalid-feedback="nameValid.text" :state="nameValid.state">
        <b-form-input v-model="order.name" :state="nameValid.state" @input="nameChange"/>
      </b-form-group>

      <b-form-group label="Email" :invalid-feedback="emailValid.text" :state="emailValid.state">
        <b-form-input v-model="order.email" :state="emailValid.state" @input="emailChange"/>
      </b-form-group>

      <b-form-group label="Phone" :invalid-feedback="phoneValid.text" :state="phoneValid.state">
        <b-form-input v-model="order.phone" :state="phoneValid.state" @input="phoneChange"/>
      </b-form-group>
      <b-alert :show="alertDesc!==''" variant="warning">{{alertDesc}}</b-alert>
      <div style="float: right">
        <b-btn @click="cancel" >Cancel</b-btn>
        <b-btn @click="submit" variant="primary" >Submit</b-btn>
      </div>
      <div style="clear: both"></div>
    </div>
    <div v-show="step !='input'">
      <H1>Thank you!</H1>
      <p>A member of our Digital Team will contact you within the next business day to discuss your campaign in more detail.
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        step: 'input',
        okTitle: 'Submit',
        prospectsTypeOther: '',
        other: false,
        order: {
          text: '',
          prospectsType: [],
          budget: '$2,500 - $4,999',
          startDate: 'ASAP',
          name: '',
          email: '',
          phone: ''
        },
        budgetOptions: [
          {value: 'Less than $2,500', text: 'Less than $2,500'},
          {value: '$2,500 - $4,999', text: '$2,500 - $4,999'},
          {value: '$5,000 - $9,999', text: '$5,000 - $9,999'},
          {value: '$10,000 - $19,999', text: '$10,000 - $19,999'},
          {value: '$20,000 or more', text: '$20,000 or more'}
        ],
        startDateOptions: [
          {value: 'ASAP', text: 'ASAP'},
          {value: '2-4 Weeks', text: '2-4 Weeks'},
          {value: '4-8 Weeks', text: '4-8 Weeks'},
          {value: 'More than 8 Weeks', text: 'More than 8 Weeks'}
        ],
        alertDesc: '',
        textValid: {
          state: null,
          text: 'please enter'
        },
        nameValid: {
          state: null,
          text: ''
        },
        emailValid: {
          state: null,
          text: ''
        },
        phoneValid: {
          state: null,
          text: ''
        }
      }
    },
    computed: {
      userInfo () {
        return this.$store.getters['user/userInfo']
      }
    },
    watch: {
      userInfo () {
        this.order.name = this.userInfo.Name
        this.order.email = this.userInfo.Email
        this.order.phone = this.userInfo.HomePhone
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.order.name = this.userInfo.Name
        this.order.email = this.userInfo.Email
        this.order.phone = this.userInfo.HomePhone
        this.step = 'input'
        this.okTitle = 'Submit'
      },
      nameChange () {
        if (this.order.name.length > 0) {
          this.nameValid.state = true
          this.nameValid.text = ''
        } else {
          this.nameValid.state = false
          this.nameValid.text = 'Name is required'
        }
      },
      emailChange () {
        if (this.order.email.length > 0) {
          this.emailValid.state = true
          this.emailValid.text = ''
        } else {
          this.emailValid.state = false
          this.emailValid.text = 'Email is required or E-mail must be valid'
        }
      },
      phoneChange () {
        if (this.order.phone.length > 0) {
          this.phoneValid.state = true
          this.phoneValid.text = ''
        } else {
          this.phoneValid.state = false
          this.phoneValid.text = 'Phone is required'
        }
      },
      textChange () {
        if (this.order.text.length >= 10) {
          this.textValid.state = true
          this.textValid.text = ''
        } else {
          this.textValid.state = false
          this.textValid.text = 'Enter at least 10 characters'
        }
      },
      validData () {
        this.textChange()
        this.nameChange()
        this.emailChange()
        this.phoneChange()
        if (!this.textValid.state || !this.nameValid.state || !this.emailValid.state || !this.phoneValid.state) {
          return true
        }
        return false
      },
      submit (evt) {
        this.alertDesc = ''
        if (this.step === 'input') {
          evt.preventDefault()
        } else {
          return
        }
        let isError = false
        if (this.other[0] === 'Other' && this.prospectsTypeOther === '') {
          this.alertDesc = 'Please enter other text.'
          return
        }
        if (this.validData()) {
          return
        }
        if (this.order.prospectsType.length === 0) {
          this.alertDesc = 'Please select prospects'
          return
        }
        let prospectString = ''
        for (let item of this.order.prospectsType) {
          if (item === 'Other') {
            item = 'Other:' + this.prospectsTypeOther
          }
          prospectString = prospectString + item + ','
        }
        prospectString = prospectString.substring(0, prospectString.length - 1)
        if (!isError) {
          this.$http.post('PlaceOrder.aspx/AddMarketingEmail', {
            name: this.order.name,
            phone: this.order.phone,
            email: this.order.email,
            accomplish: this.order.text,
            prospects: prospectString,
            campaignBudget: this.order.budget,
            startDate: this.order.startDate
          }).then(resp => {
            this.step = 'success'
            this.okTitle = 'Close'
          }, resp => {
          })
        }
      },
      cancel () {
        window.parent.$.fn.colorbox.close()
      }
    }
  }
</script>

<style scoped>
.the-box {
  background-color: #fff;
  padding: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/DigitalCampaigns.vue